<script setup lang="ts">
import LoadingAnimation from "../Loading.vue";

defineProps<{
  tone: "loading" | "empty" | "error";
  title: string;
  message: string;
}>();
</script>

<template>
  <section class="dashboard-card rounded-[1.5rem] px-6 py-8">
    <LoadingAnimation
      v-if="tone === 'loading'"
      :context-message="title"
      class="dashboard-text-primary"
    />
    <div v-else class="max-w-2xl">
      <p
        class="text-xs font-semibold tracking-[0.18em] uppercase"
        :class="tone === 'error' ? 'text-red-400' : 'dashboard-text-link'"
      >
        {{ tone === "error" ? "Attention needed" : "Nothing to display yet" }}
      </p>
      <h2 class="dashboard-text-primary mt-3 text-2xl font-semibold">
        {{ title }}
      </h2>
      <p class="dashboard-text-secondary mt-3 text-sm leading-6">
        {{ message }}
      </p>
    </div>
  </section>
</template>
